// An organization's place in its hierarchy, "CODELCO › División El Teniente":
// each step opens that organization's card (onAbrir(id)); the last one is the
// organization itself. ruta: [{ id, nombre_comercial }], top first.
export default function ComercialRuta({ ruta, onAbrir }) {
  if (!ruta?.length) return null
  return (
    <nav className="flex flex-wrap items-center gap-x-1 text-xs text-gray-500 min-w-0">
      {ruta.map((o, i) => {
        const ultima = i === ruta.length - 1
        return (
          <span key={o.id} className="inline-flex items-center gap-1 min-w-0">
            {onAbrir && !ultima
              ? <button type="button" onClick={() => onAbrir(o.id)} className="truncate hover:text-gray-900 hover:underline">{o.nombre_comercial}</button>
              : <span className={`truncate ${ultima ? 'text-gray-700 font-medium' : ''}`}>{o.nombre_comercial}</span>}
            {!ultima && <span aria-hidden="true" className="text-gray-300">›</span>}
          </span>
        )
      })}
    </nav>
  )
}
